// extracted by mini-css-extract-plugin
export default {"modalBox":"styles_modalBox__ZDYw2","hidden":"styles_hidden__1vmdP","modalBody":"styles_modalBody__76rjU"};